import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import SettingsReducer from './SettingsReducer';
import userReducer from './userReducer';
import answerReducer from './answerReducer';
import sectionsReducer from './sectionsReducer';
import formSettingsReducer from './formSettingsReducer';
import documentReducer from './documentReducer';
import sessionReducer from './sessionReducer';
import traineeReducer from './traineeReducer';

// Slice Redux Toolkit
import eSignatureReducer from './eSignatureReducer';
import contributorReducer from './contributorReducer';
import formationsReducer from './formationsReducer';
import formationsSessionReducer from './formationsSessionReducer';
import usersReducer from './usersReducer';
import uploadImageOrganisationReducer from './imageService/organisation/reducer';
import kanbanReducer from './kanbanReducer';
import planificationReducer from './planificationReducer';
import editImageFormationSessionReducer from './imageService/formationSession/editImageFormationSessionReducer';
import editImageContributoByBtnClickReducer from './imageService/contributor/modifByBtnClick/editImageContributoByBtnClickReducer';

// Combinaison des réducteurs traditionnels et des slices
const rootReducer = combineReducers({
  user: userReducer,
  answers: answerReducer,
  session: sessionReducer,
  document: documentReducer,
  sections: sectionsReducer,
  settings: SettingsReducer,
  formSettings: formSettingsReducer,
  esignature: eSignatureReducer, // Utilisation du slice de Redux Toolkit
  trainee: traineeReducer,
  contributor: contributorReducer,
  users: usersReducer,
  formations: formationsReducer,
  formationsSession: formationsSessionReducer,
  kanban: kanbanReducer, // Ajout du kanbanReducer
  planification: planificationReducer,
  editImageFormationSession: editImageFormationSessionReducer,
  editImageContributoByBtnClick: editImageContributoByBtnClickReducer,
  uploadImageOrganisation: uploadImageOrganisationReducer,
});

// Configuration du store avec Redux Toolkit
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['sections.0.questions.0.date', 'sections.0.questions.0.time'], // Ignore le chemin concerné
      },
    }),
  // Redux DevTools et middleware sont configurés automatiquement
});

export default store;

// export default createStore(
//   combineReducers({
//     settings: SettingsReducer,
//     user: userReducer,
//     sections: sectionsReducer,
//     answers: answerReducer,
//     formSettings: formSettingsReducter,
//   }),
//   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );

/* export default configureStore({
  reducer: {
    settings: SettingsReducer,
    user: userReducer,
    sections: sectionsReducer,
    answers: answerReducer,
    formSettings: formSettingsReducter,
    esignature:eSignatureReducer
  },
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
) */
